module.exports = "pegasus/assets/graycircle-facebook.png";